import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const summaryApi = createApi({
  reducerPath: 'summaryApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_API_CHECKOUT}`,
  }),
  keepUnusedDataFor: 3600,
  tagTypes: ['Summary'],
  endpoints: (builder) => ({
    getSummary: builder.mutation({
      query: (body) => ({
        url: 'order-summary-core/api/v1/summary/booking',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useGetSummaryMutation } = summaryApi;
